// @flow

import {
  getActiveColor,
} from './color';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';
import type { State as RouterState } from '../../../router/types';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
  router: RouterState,
};

export const getDeliverytime = (state: GlobalState): ?number => {
  const color = getActiveColor(state);
  return color ? color.deliverytime : null;
};

export default null;
